import { render, staticRenderFns } from "./typePlatformTree.vue?vue&type=template&id=caddf6ee&scoped=true"
import script from "./typePlatformTree.vue?vue&type=script&lang=js"
export * from "./typePlatformTree.vue?vue&type=script&lang=js"
import style0 from "./typePlatformTree.vue?vue&type=style&index=0&id=caddf6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caddf6ee",
  null
  
)

export default component.exports